var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg18Ock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512.691,
    height: 108,
    viewBox: "0 0 512.691 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(-0.315 -0.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-HD",
    transform: "translate(0.315 0.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-2",
    "data-name": "Menu",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-White",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M12.29,1.936A.964.964,0,0,1,13,1.652h5.257a.88.88,0,0,1,.994,1V102.7a.88.88,0,0,1-.994,1H13.568a.879.879,0,0,1-.994-1V11.122l-7.529,7.55a.817.817,0,0,1-1.35,0L.355,15.324a.892.892,0,0,1,0-1.424Z",
    transform: "translate(0 3.029)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M21.248,27.095a18.061,18.061,0,0,0,5.47,13.246,17.974,17.974,0,0,0,13.213,5.484,17.978,17.978,0,0,0,13.213-5.484,18.066,18.066,0,0,0,5.47-13.246,18.071,18.071,0,0,0-5.47-13.245A17.982,17.982,0,0,0,39.932,8.367a17.978,17.978,0,0,0-13.213,5.483,18.066,18.066,0,0,0-5.47,13.245M39.932,96.957a21.176,21.176,0,0,0,15.557-6.482,22.04,22.04,0,0,0,0-31.19A21.181,21.181,0,0,0,39.932,52.8a21.181,21.181,0,0,0-15.557,6.482,22.04,22.04,0,0,0,0,31.19,21.176,21.176,0,0,0,15.557,6.482M52.575,49.1a28.78,28.78,0,0,1,16.056,25.78,27.81,27.81,0,0,1-8.454,20.368,27.555,27.555,0,0,1-20.246,8.4,28.654,28.654,0,0,1-28.7-28.771A28.885,28.885,0,0,1,27.216,49.1a25.341,25.341,0,0,1-12.644-22A24.5,24.5,0,0,1,22.029,9.151a24.232,24.232,0,0,1,17.9-7.479,24.382,24.382,0,0,1,17.9,7.479A24.615,24.615,0,0,1,65.22,27.095a25.207,25.207,0,0,1-3.478,12.89A24.531,24.531,0,0,1,52.575,49.1",
    transform: "translate(28.762 3.08)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M159.088,54.686,140.617,10.108,122.148,54.686ZM143.672,1.632a.963.963,0,0,1,.923.57l41.485,100.2a.927.927,0,0,1-.071.926.958.958,0,0,1-.853.427h-5.113a.954.954,0,0,1-.923-.641L161.859,61.38H119.378l-17.334,41.73a.955.955,0,0,1-.923.641H96.005a1.074,1.074,0,0,1-.852-.427.918.918,0,0,1-.072-.926L136.567,2.2a.963.963,0,0,1,.925-.57Z",
    transform: "translate(243.239 2.978)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(445.503 4.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M67.219,100.569a1,1,0,0,1,.213,1.069.881.881,0,0,1-.923.64H59.617a.956.956,0,0,1-.709-.285L6.994,56.417v45.007a.88.88,0,0,1-.994,1H1.311a.88.88,0,0,1-1-1V1.441a.881.881,0,0,1,1-1H6a.881.881,0,0,1,.994,1V45.948L55.783.586A.966.966,0,0,1,56.493.3H63.17a.964.964,0,0,1,.925.57.837.837,0,0,1-.214,1.067L11.255,51.218Z",
    transform: "translate(-0.316 -0.301)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M46.154,15.334a9.588,9.588,0,0,0-3.6,7.37c0,5.474,4.887,9.928,10.894,9.928a11.466,11.466,0,0,0,7.2-2.5L47.031,14.686c-.31.208-.6.424-.878.648",
    transform: "translate(108.976 36.405)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M82.347,44.5H79.011a18.635,18.635,0,0,1-3.133,9.354l4.481,5.081-2.7,2.389L73.4,56.488a15.045,15.045,0,0,1-9.579,3.41c-7.99,0-14.49-6.07-14.49-13.532A13.175,13.175,0,0,1,54.242,36.21c.3-.251.626-.48.955-.7a9.753,9.753,0,0,1-1.289-4.839,10.13,10.13,0,0,1,16.624-7.561V21.381h3.6v9.63h-3.6l-.03-.341a6.212,6.212,0,0,0-1.47-4A6.556,6.556,0,0,0,64,24.356a6.416,6.416,0,0,0-6.5,6.313,6.19,6.19,0,0,0,1.758,4.319l.246.256-.023.02,13.92,15.785A15.417,15.417,0,0,0,75.4,44.5H71.938v-3.6H82.347ZM65.143,5.446C60.729,8.173,38.507,17.015,38.507,17.015v37.38c0,16.1,24.313,21.689,26.635,24.919,2.321-3.23,26.634-8.818,26.634-24.919V17.015S69.555,8.173,65.143,5.446Z",
    transform: "translate(98.605 12.744)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M99.013,11.594A45.331,45.331,0,0,0,74.8,35.862a45.717,45.717,0,0,0,0,35.487A45.492,45.492,0,0,0,162.2,53.6a45.489,45.489,0,0,0-27.792-42.011,45.425,45.425,0,0,0-35.4,0M96.4,101.849a52.735,52.735,0,0,1-27.813-27.88,52.9,52.9,0,0,1,0-40.726A53.5,53.5,0,0,1,79.8,16.6,52.3,52.3,0,0,1,96.4,5.435a51.666,51.666,0,0,1,40.625,0,51.822,51.822,0,0,1,27.741,27.808,52.058,52.058,0,0,1,0,40.726,52.445,52.445,0,0,1-11.141,16.64,53.323,53.323,0,0,1-16.6,11.24,52.518,52.518,0,0,1-40.625,0",
    transform: "translate(165.19 2.064)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(113.131 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(76.505 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M2.508,25.6l1.5.6L24.71,2.638,21.743.018.108,24.639c.835.336,1.647.662,2.4.962",
    transform: "translate(-0.108 -0.018)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(0.06 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M22.435,25.6c.738-.294,1.533-.614,2.352-.943L3.137.018.168,2.638,20.888,26.217Z",
    transform: "translate(-0.168 -0.018)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    d: "M26.748,23.221,9.8,42.512C8.028,38.3,6.128,36.089,4,35.773A3.6,3.6,0,0,0,.767,37.052l-.616.778,8.46,9.629,19.9-22.652q-.911-.762-1.768-1.586",
    transform: "translate(-0.152 59.395)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    d: "M48.329,37.028A3.605,3.605,0,0,0,45.1,35.75c-2.131.315-4.031,2.522-5.8,6.738L22.376,23.23q-.857.825-1.77,1.584l19.879,22.62,8.461-9.629Z",
    transform: "translate(52.224 59.419)",
    fillRule: "evenodd"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18Ock);
export default __webpack_public_path__ + "static/media/18&OCK.6c60351b81922595ec74269f1cc6c593.svg";
export { ForwardRef as ReactComponent };